
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'Login',
  data () {
    return {
      hasLogo: null,
      username: undefined,
      password: undefined,
      typed: false,
      showPassword: false
    }
  },
  created () {
    loading.pop()
  },
  methods: {
    inputouPassword () {
      this.typed = true
    },
    togglePassword () {
      this.showPassword = !this.showPassword
    },
    validateAndSignIn () {
      this.$emit('Login', this.username, this.password)
    },
    getValidationState (fieldName) {
      const field = this.$validator.fields.find({ name: fieldName })

      if (!field) return null

      const isDirty = field.flags.dirty
      const isValid = !this.errorsVee.has(fieldName)
      return isDirty ? isValid : null
    },
    onresetPassword () {
      this.$emit('ResetPassword')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/auth/login/login.js